import { TableBody, TableEmpty, TableLoading } from '@/ui';

import Row from './Row';

import type { Company } from '@/types';
import type { FC } from 'react';

interface ListProps {
  companies: Company[];
  headers: string[];
  isLoading: boolean;
}

const List: FC<ListProps> = ({
  companies = [],
  isLoading = false,
  headers = [],
}) => {
  if (isLoading) {
    return <TableLoading columns={headers.length} />;
  }
  if (!companies.length) {
    return (
      <TableEmpty columns={headers.length} message="No companies found ..." />
    );
  }

  return (
    <TableBody>
      {companies.map((company) => (
        <Row key={`${company.id}-company-management`} {...company} />
      ))}
    </TableBody>
  );
};

export default List;
